export function validaData(value) {
    var date = value;
    var ardt = [];
    var ExpReg = new RegExp("(0[1-9]|[12][0-9]|3[01])/(0[1-9]|1[012])/[12][0-9]{3}");
    
    if(!date)
        return false;
        
    ardt = date.split("/");    
    
    if(date.search(ExpReg) === -1) 
        return false;                

    if(((ardt[1] === 4)||(ardt[1] === 6)||(ardt[1] === 9)||(ardt[1] === 11))&&(ardt[0] > 30)) 
        return false;
            
    if(ardt[1] === 2) {
        if ((ardt[0] > 28)&&((ardt[2]%4) !== 0)) 
            return false;

        if ((ardt[0]>29)&&((ardt[2]%4)===0))
            return false;
    }
            
    return true;
} 

export function temTexto(logradouro, endereco) {                
    let txtEndereco = endereco;            
    var enderecos = txtEndereco.split(' ');                  

    if(enderecos[0] === logradouro)
        return true;

    return false;
} 

export function validarCNPJ(cnpj) {        
    cnpj = cnpj.replace(/[^\d]+/g,'');

    if(cnpj === '') 
        return false;
 
    if (cnpj.length !== 14)
        return false;

    // Elimina CNPJs invalidos conhecidos
    if (cnpj === "00000000000000" || 
        cnpj === "11111111111111" || 
        cnpj === "22222222222222" || 
        cnpj === "33333333333333" || 
        cnpj === "44444444444444" || 
        cnpj === "55555555555555" || 
        cnpj === "66666666666666" || 
        cnpj === "77777777777777" || 
        cnpj === "88888888888888" || 
        cnpj === "99999999999999")
        return false;
                 
    // Valida DVs
    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0,tamanho);
    let digitos = cnpj.substring(tamanho);        
    let soma = 0;
    let pos = tamanho - 7;        

    for (let i = tamanho; i >= 1; i--) {            
        soma += numeros.charAt(tamanho - i) * pos--;

        if (pos < 2)
            pos = 9;
    }                

    let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;        

    let primeiroDigito = digitos.charAt(0);        

    if (Number(resultado) !== Number(primeiroDigito))
        return false;                

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0,tamanho);
    soma = 0;
    pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
    
        if (pos < 2)
            pos = 9;
    }

    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

    let segundoDigito = digitos.charAt(1);

    if (Number(resultado) !== Number(segundoDigito))
        return false;
       
    return true;
}

export function validarEmail(email) {    
    var ExpReg = new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g);

    if(!email)
        return false;

    if(!ExpReg.test(email)) 
        return false;    

    return true;
}